import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pass-index mt20" }
const _hoisted_2 = { class: "bottom" }
const _hoisted_3 = { class: "pas" }
const _hoisted_4 = {
  key: 0,
  class: "r-text"
}
const _hoisted_5 = {
  key: 1,
  class: "r-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "form",
      model: _ctx.ruleForm2,
      rules: _ctx.rules2,
      class: "demo-ruleForm2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "账号",
          prop: "mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.ruleForm2.mobile,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm2.mobile) = $event)),
              placeholder: "请输入手机号",
              maxlength: "11",
              class: "el-int"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "密码",
          prop: "password",
          class: "password mt20"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.ruleForm2.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm2.password) = $event)),
              placeholder: "请输入密码",
              class: "el-int",
              type: "password"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          class: _normalizeClass(_ctx.isAffirm ? 'register-btn isAffirm' : 'register-btn'),
          disabled: !_ctx.isAffirm,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit(_ctx.form)))
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("登录", -1)
          ]))]),
          _: 1
        }, 8, ["class", "disabled"])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.checked,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checked) = $event)),
          size: "large",
          class: "checkbox"
        }, null, 8, ["modelValue"]),
        _cache[7] || (_cache[7] = _createElementVNode("span", null, "记住密码", -1))
      ]),
      (_ctx.windowW > 850)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.forgetPassword && _ctx.forgetPassword(...args)))
            }, "忘记密码"),
            _cache[8] || (_cache[8] = _createTextVNode(" | ", -1)),
            _createElementVNode("a", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.passRegister && _ctx.passRegister(...args)))
            }, "注册")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/forgetPassword" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("忘记密码", -1)
              ]))]),
              _: 1
            }),
            _cache[11] || (_cache[11] = _createTextVNode(" | ", -1)),
            _createVNode(_component_router_link, { to: "/register" }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("注册", -1)
              ]))]),
              _: 1
            })
          ]))
    ])
  ]))
}